$(document).ready(function () {
  // const embroideryProductId = 43019261313243;
  // const embroideryPropertyKey = "刺繡情報";
  // function validateEmbroidery() {
  //   fetch("/cart.js", {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((response) => response.json())
  //     .then((cart) => {
  //       console.log("Thông tin giỏ hàng:", cart);
  //       const embroideryProduct = cart.items.find(
  //         (item) => item.variant_id === embroideryProductId
  //       );
  //       const embroideryQuantity = embroideryProduct
  //         ? embroideryProduct.quantity
  //         : 0;
  //       console.log("embroideryQuantity", embroideryQuantity);
  //       const totalEmbroideryProductQuantity = cart.items.reduce(
  //         (sum, item) => {
  //           return item.properties && item.properties[embroideryPropertyKey]
  //             ? sum + item.quantity
  //             : sum;
  //         },
  //         0
  //       );
  //       console.log(
  //         "totalEmbroideryProductQuantity",
  //         totalEmbroideryProductQuantity
  //       );
  //     })
  //     .catch((error) => console.error("Lỗi khi lấy giỏ hàng:", error));
  // }
  // $("cart-remove-button").click(function () {
  //   console.log("-------------------------------------------------");
  //   validateEmbroidery();
  // });
  // $(".save-delivery-info").click(function (event) {
  //   event.preventDefault();
  //   console.log("Don't forget to save the delivery information");
  //   fetch("/cart.js", {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((response) => response.json())
  //     .then((cart) => {
  //       console.log("Thông tin giỏ hàng:", cart);
  //       // Xử lý thông tin giỏ hàng ở đây
  //     })
  //     .catch((error) => console.error("Lỗi khi lấy giỏ hàng:", error));
  //   fetch("/cart/change.js", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       line: "1",
  //       quantity: "1",
  //       sections: [
  //         "template--18716597453019__cart-items",
  //         "cart-icon-bubble",
  //         "cart-live-region-text",
  //         "template--18716597453019__cart-footer",
  //       ],
  //       sections_url: "/cart",
  //     }),
  //   })
  //     .then((response) => response.json())
  //     .then((cart) => {
  //       getCart();
  //       console.log("Giỏ hàng đã được cập nhật:", cart);
  //     })
  //     .catch((error) => console.error("Lỗi khi cập nhật giỏ hàng:", error));
  // });
});
